import React from 'react';
import ReactDOM from 'react-dom';
import { ExperienceProvider, ContextBuilder } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { App } from './App';
import { getIsCompatiblePage, waitForIdle } from './utils/assistant-utils';

const { experienceContext } = ContextBuilder.client({
  expConfiguration: window?.__EXPERIENCE_PROPS__?.expConfiguration
});

if (typeof BroadcastChannel !== 'undefined' && getIsCompatiblePage()) {
  waitForIdle(() => {
    ReactDOM.render(
      <React.StrictMode>
        <ErrorBoundary name="magic-apron-assistant-loader">
          <ExperienceProvider value={experienceContext}>
            <App />
          </ExperienceProvider>
        </ErrorBoundary>
      </React.StrictMode>,
      document.getElementById('magic-apron-loader')
    );
  });
}
